import { elementToForgeDoc } from "../../../../utils/elementToForgeDoc";

/**
 * THIS SECTION WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * This component was generated against an existing platform component.
 * If you are seeing lint errors in this file, it means that this file's dependencies have been modified and the component will need to be regenerated.
 *
 * Please view https://hello.atlassian.net/wiki/spaces/ECO/pages/3358130330/How+to+Regenerate+UI+Kit+Components for more information on how to proceed.
 *
 * For further questions, please ping the #help-forge-ui channel.
 *
 * @codegen <<SignedSource::46da2f64e1c547719231e8c8166c6875>>
 * @codegenId #textfield
 * @codegenCommand yarn workspace @atlassian/forge-ui codegen textfield
 * @codegenParams { "hasFieldProps": true, "props": { "appearance": true, "elemAfterInput": { "value": "elemAfterInput ? props.render(elementToForgeDoc(elemAfterInput as React.ReactElement)) : null", "comment": "forge/react reconciler does not convert components in props into ForgeDoc. We need to do it manually here" }, "elemBeforeInput": { "value": "elemBeforeInput ? props.render(elementToForgeDoc(elemBeforeInput as React.ReactElement)): null", "comment": "forge/react reconciler does not convert components in props into ForgeDoc. We need to do it manually here" }, "isCompact": true, "isReadOnly": true, "isMonospaced": true, "onMouseDown": false, "placeholder": true, "testId": true, "width": true, "type": true, "defaultValue": true, "min": true, "max": true, "maxLength": true, "minLength": true, "pattern": true } }
 * @codegenDependency ../../../../../../../design-system/textfield/src/types.tsx <<SignedSource::79a19c04b12f647345f145faccdbfc6d>>
 * @codegenDependency ../../../../../../../design-system/textfield/src/index.tsx <<SignedSource::a194ea29db37d08de080f319d98baf04>>
 */
/* eslint @repo/internal/codegen/signed-source-integrity: "warn" */
import React from 'react';
import type { RenderFn } from '@atlassian/forge-ui-types';
import PlatformTextfield from '@atlaskit/textfield';
import { adaptEventHandler } from "../../../utils";
import type { EventHandlerProps } from "../../types";

type PlatformTextfieldProps = React.ComponentProps<typeof PlatformTextfield>;

export type TextfieldProps = Pick<
  PlatformTextfieldProps,
  'appearance' | 'elemAfterInput' | 'elemBeforeInput' | 'isCompact' | 'isReadOnly' | 'isMonospaced' | 'placeholder' | 'testId' | 'width' | 'type' | 'defaultValue' | 'min' | 'max' | 'maxLength' | 'minLength' | 'pattern'
 | 'id' | 'isRequired' | 'isDisabled' | 'isInvalid' | 'onChange' | 'onBlur' | 'onFocus' | 'value' | 'aria-invalid' | 'aria-labelledby' | 'name'
> & Pick<EventHandlerProps, 'onChange' | 'onBlur' | 'onFocus'>;

export const Textfield = (props: Parameters<RenderFn>[0]) => {
  const {
    appearance,
    elemAfterInput,
    elemBeforeInput,
    isCompact,
    isReadOnly,
    isMonospaced,
    placeholder,
    testId,
    width,
    type,
    defaultValue,
    min,
    max,
    maxLength,
    minLength,
    pattern,
    // Field props
    id,
    isRequired,
    isDisabled,
    isInvalid,
    onChange,
    onBlur,
    onFocus,
    value,
    "aria-invalid": ariaInvalid,
    "aria-labelledby": ariaLabelledby,
    name,
  } = props.forgeDoc.props as TextfieldProps;
  return (
    <PlatformTextfield
      appearance={appearance}
      // forge/react reconciler does not convert components in props into ForgeDoc. We need to do it manually here
      elemAfterInput={elemAfterInput ? props.render(elementToForgeDoc(elemAfterInput as React.ReactElement)) : null}
      // forge/react reconciler does not convert components in props into ForgeDoc. We need to do it manually here
      elemBeforeInput={elemBeforeInput ? props.render(elementToForgeDoc(elemBeforeInput as React.ReactElement)): null}
      isCompact={isCompact}
      isReadOnly={isReadOnly}
      isMonospaced={isMonospaced}
      placeholder={placeholder}
      testId={testId}
      width={width}
      type={type}
      defaultValue={defaultValue}
      min={min}
      max={max}
      maxLength={maxLength}
      minLength={minLength}
      pattern={pattern}
      // Field props
      id={id}
      isRequired={isRequired}
      isDisabled={isDisabled}
      isInvalid={isInvalid}
      onChange={adaptEventHandler(onChange)}
      onBlur={adaptEventHandler(onBlur)}
      onFocus={adaptEventHandler(onFocus)}
      value={value}
      aria-invalid={ariaInvalid}
      aria-labelledby={ariaLabelledby}
      name={name}
    />
  );
};
/**
 * @codegenEnd
 */
